import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Are you based in Canada and do you understand CRA rules?",
    a: "Yes. We're based in Ontario and serve clients across Canada. Every workflow — from HST/GST tracking to year-end packages — is built around current CRA requirements.",
  },
  {
    q: "Do I have to switch accounting software?",
    a: "Not necessarily. We work primarily with QuickBooks Online and Xero, and use Dext for expense automation. If you're already on one of these, we onboard onto your file. If you're using something else, we'll recommend the best fit during the consultation.",
  },
  {
    q: "What does 'fixed monthly pricing' actually mean?",
    a: "You pay a flat monthly fee scoped to your transaction volume and complexity. No hourly billing, no surprise invoices. If your business changes materially, we re-scope together — transparently.",
  },
  {
    q: "I'm behind on bookkeeping. Can you catch me up?",
    a: "Yes. Catch-up and clean-up projects are one of our most common engagements. We'll quote a one-time fee ($500–$3,000 typical range) to bring everything current, then transition you onto a monthly plan.",
  },
  {
    q: "Do you handle payroll?",
    a: "We coordinate payroll and track remittances. We liaise with payroll providers (Wagepoint, Payworks, ADP, etc.) so your books, taxes, and pay runs always reconcile.",
  },
  {
    q: "When will I receive my monthly financial statements?",
    a: "By the 15th of the following month, every month. That's our standard — and we treat it as non-negotiable.",
  },
  {
    q: "Do you file my corporate tax return?",
    a: "We prepare a clean year-end package for your accountant for corporations. For sole proprietors, we offer tax services directly. We're happy to coordinate with your existing accountant either way.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      className="section-anchor py-24 md:py-32 bg-cream"
      data-testid="faq-section"
    >
      <div className="px-6 md:px-12 lg:px-20 max-w-5xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <div className="uppercase text-xs tracking-[0.25em] font-bold text-gold mb-4">
              Frequently Asked
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-navy tracking-tight leading-[1.05]">
              Questions, <span className="italic">answered.</span>
            </h2>
          </div>
          <p className="md:col-span-7 text-stone md:text-lg leading-relaxed md:pt-4">
            Still have something specific in mind? Send it through the contact form and
            we&rsquo;ll respond within 24 hours.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-border"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-serif text-xl md:text-2xl text-navy hover:no-underline text-left py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone text-base leading-relaxed pb-6 pr-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
